import { render } from "./CensusModal.vue?vue&type=template&id=12f58aff&scoped=true&ts=true"
import script from "./CensusModal.vue?vue&type=script&lang=ts"
export * from "./CensusModal.vue?vue&type=script&lang=ts"

import "./CensusModal.vue?vue&type=style&index=0&id=12f58aff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f58aff"]])

export default __exports__